import { useNavigate } from "react-router-dom";
import { WhatsappLogo, Phone, PaperPlaneTilt } from "@phosphor-icons/react";
import { SITE, openWhatsApp } from "@/lib/site";

export const FloatingActions = () => {
  const navigate = useNavigate();
  return (
    <div
      className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3"
      data-testid="floating-actions"
    >
      <button
        onClick={() => openWhatsApp()}
        data-testid="whatsapp-fab"
        aria-label="Chat on WhatsApp"
        className="group flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 transition-transform hover:scale-110"
      >
        <WhatsappLogo size={30} weight="fill" />
        <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366] opacity-30" />
      </button>

      <a
        href={`tel:${SITE.phoneRaw}`}
        data-testid="call-fab"
        aria-label="Call now"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-forest text-white shadow-lg shadow-black/20 transition-transform hover:scale-110"
      >
        <Phone size={26} weight="fill" />
      </a>

      <button
        onClick={() => navigate("/enquiry")}
        data-testid="enquire-fab"
        aria-label="Enquire now"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-gold text-forest shadow-lg shadow-black/20 transition-transform hover:scale-110"
      >
        <PaperPlaneTilt size={26} weight="fill" />
      </button>
    </div>
  );
};

export default FloatingActions;
